import React from 'react';
import { HeadCard } from '../../structure/card/HeadCard';
import { DatatableAuxiliares } from './DatatableAuxiliares';

export const AuxiliaresPage = () => {
    return (
        <div className="content-wrapper">
            <HeadCard titulo="Auxiliares" />
            <section className="content">
                <div className="card">
                    <div className="card-header">
                    </div>
                    <DatatableAuxiliares />
                </div>
            </section>
        </div>
    );
};
